import { isPossiblePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import { z } from 'zod';

export const castToNumber = z.preprocess((val) => Number(val), z.number());
export const requiredPhoneNumberSchema = z
  .string()
  .min(1, 'Required')
  .refine(isPossiblePhoneNumber, 'This phone number cannot exist')
  .refine(
    (value) =>
      isValidPhoneNumber(value, {
        defaultCountry: 'US',
      }),
    'Invalid phone number',
  );

// 5-digit or ZIP+4, the rule the address forms across the app type out inline.
// `zipCodeValidation` in tools/helpers is not a substitute: it returns an error message
// rather than a boolean, and its rule is digits-only max 10, which rejects ZIP+4 and
// accepts '123'.
const ZIP_CODE_REGEX = /^\d{5}(-\d{4})?$/;

/**
 * Blank is valid — the caller decides whether the field is required. Don't wrap this in
 * `.optional()`: useFormWithSearchParams unwraps one level of zod internals only, and the
 * `.refine()` already makes this a ZodEffects.
 */
export const optionalZipCodeSchema = z
  .string()
  .trim()
  .refine(
    (v) => !v || ZIP_CODE_REGEX.test(v),
    'ZIP code must be 5 digits or 5+4 format (e.g., 12345 or 12345-6789)',
  );

const TOOL_FUND_PURCHASE_ORDER_MAX_LENGTH = 200;

export const toolFundPurchaseOrderSchema = z.string().max(TOOL_FUND_PURCHASE_ORDER_MAX_LENGTH, {
  message: `Purchase order must be less than ${TOOL_FUND_PURCHASE_ORDER_MAX_LENGTH} characters`,
});
